export default {
  title: {
    id: 'bo_seller.kyb.legal_representative.title',
    defaultMessage: 'Legal representative details',
  },
  description: {
    id: 'bo_seller.kyb.legal_representative.description',
    defaultMessage:
      'Fill out details for the legal representative, that is, a person who has the authority to sign contracts on behalf of the business. Their name can be found in company filings.',
  },
  sameAsAccountRequesterLabel: {
    id: 'bo_seller.kyb.legal_representative.same_as_account_requester',
    defaultMessage:
      'Check this box if the legal representative is also the account requester.',
  },
  saveButton: {
    id: 'bo_seller.kyb.legal_representative.save_button',
    defaultMessage: 'Save',
  },
} as const
